import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaHover } from 'themes/mixins/mediaHover';

import { Button } from 'components/Button';

const Container = styled.div`
  display: flex;
  gap: 4rem;

  padding: 2rem;
`;

const BlindImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 15rem;
  height: 15rem;

  border: 0.2rem solid ${pickColor('black')};
  border-radius: ${({ theme }) => theme.borderRadius.base};
  background-color: ${pickColor('blueDark')};

  cursor: pointer;

  transition: background-color ${({ theme }) => theme.transitionSpeed} linear;

  ${mediaHover(css`
    background-color: ${pickColor('blue')};
  `)}
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;

  gap: 2rem;
`;

const DeleteButton = styled(Button)`
  height: 2rem;
  margin-left: auto;
`;

export { Container, BlindImage, InputGroup, DeleteButton };
